import { render } from "./App.vue?vue&type=template&id=277e2d09&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=277e2d09&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__